/**
 * Template loader for configurator
 * Manages different template types and instantiates them with the correct model ID
 */

import { Configurator, ConfiguratorConfig } from '../types';
import { createBaseTemplate } from './baseTemplate';
import { createTwoOptionsTemplate } from './twoOptionsTemplate';
import { createWoodTemplate } from './woodTemplate';
import { createAvantiTemplate } from './avantiTemplate';
import { createWorkspaceTemplate } from './workspaceTemplate';
import { createMeranoTemplate } from './meranoTemplate';
import { createDualTemplate } from './dualTemplate';
import { createBossTemplate } from './bossTemplate';
import { createPredefinedConfigsTemplate } from './predefineConfigsTemplate';

class TemplateLoader {
  /**
   * Loads a template based on configurator type and model ID
   * @param configuratorInfo Contains id, type, and modelId
   * @returns Configurator configuration
   */
  loadTemplate(configuratorInfo: Configurator): ConfiguratorConfig {
    if (!configuratorInfo || !configuratorInfo.modelId) {
      throw new Error('Invalid configurator information');
    }
    
    // Default template
    let config: ConfiguratorConfig;
    
    // Select template based on configurator type
    switch (configuratorInfo.type) {
      case 'base':
        config = createBaseTemplate(configuratorInfo.modelId);
        break;
        
      case 'two-options':
        config = createTwoOptionsTemplate(configuratorInfo.modelId);
        break;
        
      case 'wood':
        config = createWoodTemplate(configuratorInfo.modelId);
        break;
        
      case 'avanti':
        config = createAvantiTemplate(configuratorInfo.modelId);
        break;

      case 'merano':
        config = createMeranoTemplate(configuratorInfo.modelId);
        break;

      case 'dual':
        config = createDualTemplate(configuratorInfo.modelId);
        break;
        
      case 'workspace':
        config = createWorkspaceTemplate(configuratorInfo.modelId);
        break;

      case 'boss':
        config = createBossTemplate(configuratorInfo.modelId);
        break;
        
      case 'predefinedConfigs':
        config = createPredefinedConfigsTemplate(configuratorInfo.modelId);
        break;

      default:
        config = createBaseTemplate(configuratorInfo.modelId);
    }
    
    return config;
  }
}

// Create singleton instance
const templateLoaderInstance = new TemplateLoader();
export default templateLoaderInstance;
